import {Activity} from '@ambit-ai/ambit-client';
import isEmpty from 'lodash/isEmpty';
import {AMBIT_MESSAGE_CONTENT_TYPE, Message} from '../chat/types';

export const getMessageDetail = (activity: Activity, userId: string) => {
  let message: Message = {
    isUser: activity.from.id === userId,
    contentType: AMBIT_MESSAGE_CONTENT_TYPE.TEXT,
    text: activity.text,
    attachments: [],
  };

  if (!isEmpty(activity?.attachments)) {
    const attachments =
      activity?.attachments?.map((attachment) => {
        const content = attachment.content;

        return {
          href: content?.buttons?.[0]?.value,
          imageUrl: content?.images?.[0]?.url,
          title: content.title,
          text: content.text,
        };
      }) || [];

    message = {
      ...message,
      contentType: AMBIT_MESSAGE_CONTENT_TYPE.CARD_HERO,
      attachments,
    };
  }

  if (!message.text && isEmpty(message.attachments)) {
    return null;
  }

  return message;
};
